// extracted by mini-css-extract-plugin
module.exports = {"block":"heroimage_block__1urgc fadeIn","wrapper":"heroimage_wrapper__ls-ey container","content":"heroimage_content__Rjfxd"};